import React from 'react'

const Editprofileskeleton = () => {
  return (
    <div className="edit-profile-container skeleton">
      <div className="profile-pic skeleton-profile-box" />
      <div className="skeleton-profile-bar short" />
      <div className="skeleton-profile-bar" />
      <div className="skeleton-profile-bar" />
      <div className="skeleton-profile-bar" />
    </div>
  )
}

export default Editprofileskeleton